import { z } from 'zod';

export const ROLE_VALUES = ['director', 'manager', 'fixator'] as const;

export const roleSchema = z.enum(ROLE_VALUES);

export type Role = (typeof ROLE_VALUES)[number];

export const roleTextMap: Record<Role, string> = {
  director: 'Руководитель',
  manager: 'Брокер',
  fixator: 'Фиксатор',
};

export const roleWeightMap: Record<Role, number> = {
  director: 2,
  fixator: 1,
  manager: 0,
};

export const isRole = (role: string): role is Role => {
  return Object.values(roleSchema.Values).includes(role as Role);
};
